/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Digicon service
 */

namespace Application.Services {
  'use strict';

  import Digicon = Models.Digicon;
  import IDigicon = Models.IDigicon;
  import Kit = Models.Kit;
  import IKit = Models.IKit;
  import IKitInfo = Models.kitInfo;
  import IPort = Models.Port;

  import IHalList = Models.IHalList;
  import HalConverter = Models.HalConverter;

  /**
   * DigiconService
   */
  export class DigiconService {
    public static $name: string = 'digiconService';
    public static $inject: string[] = [
      'backendService',
      'healthService',
      'vnoService',
    ];

    private backendBaseUrl: string = window.backendUrl;
    private servicePath: string = '';
    private backendUrl: string =
      this.backendBaseUrl + this.servicePath + 'digicons';

    constructor(
      private backendService: BackendService,
      private healthService: HealthService,
      private vnoService: Services.VnoService
    ) {}

    public getAllDigiconsPromise(): ng.IPromise<IDigicon[]> {
        let url: string = this.backendUrl + '/filtered?size=5000&';
        return this.backendService
        .get(url)
        .then((result: ng.IHttpPromiseCallbackArg<IHalList<IDigicon>>) => {
          let halElement: IHalList<IDigicon> = result.data;
          let converted: IDigicon[] = HalConverter.convertList(
            halElement,
            Digicon.Empty
          );
          return converted;
        });
    }

      public getAllDigiconsFilteredPromise(status?: String[], matchDay?: String[], matchNumber?: String[], kit?: String[],
                                           mode?: String[], port?: String[], role?: String[],
                                           mainGateway?: String[], backupGateway?: String[]): ng.IPromise<IDigicon[]> {
          let url: string = this.backendUrl + '/filtered?size=5000&';
          let encodedParams: string = Common.Utils.encodeQueryData({
              status: status,
              matchDay: matchDay,
              matchNumber: matchNumber,
              kit: kit,
              mode: mode,
              port: port,
              role: role,
              mainGateway: mainGateway,
              backupGateway: backupGateway,

          });
          url = url + encodedParams;
          return this.backendService
              .get(url)
              .then((result: ng.IHttpPromiseCallbackArg<IHalList<IDigicon>>) => {
                  let halElement: IHalList<IDigicon> = result.data;
                  let converted: IDigicon[] = HalConverter.convertList(
                      halElement,
                      Digicon.Empty
                  );
                  return converted;
              });
      }

    public getMainGatewaysPromise(): ng.IPromise<String[]> {
      return this.backendService
        .get(this.backendUrl + '/mainGateways')
        .then((result: ng.IHttpPromiseCallbackArg<String[]>) => {
          let halElement: String[] = result.data;
          return halElement;
        });
    }

    public startKit(kitId: number): ng.IPromise<String[]> {
        return this.backendService
          .get(this.backendUrl + '/' + kitId + "/start")
          .then((result: ng.IHttpPromiseCallbackArg<String[]>) => {
            let halElement: String[] = result.data;
            return halElement;
          });
    }

      public kitStatus(kitId: number): ng.IPromise<IKit> {
          return this.backendService
              .get(this.backendUrl + '/' + kitId.toString() + "/kitStatus")
              .then((result: ng.IHttpPromiseCallbackArg<IKit>) => {
                  let halElement: Kit = result.data;
                  return halElement;
              });
      }

    public stopKit(kitId: number): ng.IPromise<String[]> {
        return this.backendService
          .get(this.backendUrl + '/' + kitId + "/stop")
          .then((result: ng.IHttpPromiseCallbackArg<String[]>) => {
            let halElement: String[] = result.data;
            return halElement;
          });
    }

    /**
     * return all kits in API
     */

    public getKits(): ng.IPromise<String[]> {
      return this.backendService
        .get(this.backendUrl + '/kits')
        .then((result: ng.IHttpPromiseCallbackArg<String[]>) => {
          let halElement: String[] = result.data;
          return halElement;
        });
    }

    public getKitsInfo(): ng.IPromise<IKitInfo[]> {
      return this.backendService
        .get(this.backendUrl + '/kitsInfo')
        .then((result: ng.IHttpPromiseCallbackArg<any[]>) => {
          return result.data;
        }).catch( (e) => {
          console.log(e);
          throw e.data.message;
        });
    }

    

    /**
     * Compare all kits with used kits and return available kits.
     */

    public async getKitsAvailable() {
      let allKits = await this.getKits();
      let matchdayKits = await (await this.getAllDigiconsPromise()).map(
        (kit) => {
          return kit.kit;
        }
      );
      let aux = allKits.filter((kit) => {
        return matchdayKits.indexOf(Number(kit)) == -1;
      });
      return aux;
    }

      /**
       * Compare all main gateways with used main gateways and return available main gateways.
       */
      public async getMainGatewaysAvailable() {
          let mainGateways = await this.getMainGatewaysPromise();
          let mainGatewaysMatchdays = await (await this.getAllDigiconsPromise()).map(
              (digicon) => {
                  return digicon.mainGateway;
              }
          );
          let aux = mainGateways.filter((mainGateway: string) => {
              return mainGatewaysMatchdays.indexOf(mainGateway) == -1;
          });
          return aux;
      }

      /**
       * Compare all backup gateways with used backup gateways and return available backup gateways.
       */

      public async getBackupGatewaysAvailable() {
          let backupGateways = await this.getBackupGatewaysPromise();
          let backupGatewaysMatchdays = await (await this.getAllDigiconsPromise()).map(
              (digicon) => {
                  return digicon.backupGateway;
              }
          );
          let aux = backupGateways.filter((mainGateway: string) => {
              return backupGatewaysMatchdays.indexOf(mainGateway) == -1;
          });
          return aux;
      }

    public getBackupGatewaysPromise(): ng.IPromise<String[]> {
      return this.backendService
        .get(this.backendUrl + '/backupGateways')
        .then((result: ng.IHttpPromiseCallbackArg<String[]>) => {
          let halElement: String[] = result.data;
          return halElement;
        });
    }

    public saveDigicon(digicon: Models.IDigicon) {
      return this.createDigicon(digicon);
    }

    public createDigicon(
      digicon: Models.IDigicon
    ): ng.IPromise<Models.IDigicon> {
      return this.backendService
        .post(this.backendUrl + '/', digicon)
        .then(
          (
            result: ng.IHttpPromiseCallbackArg<Models.IHalElement<IDigicon>>
          ) => {
            let converted: IDigicon = HalConverter.convertElement(
              result.data,
              Digicon.Empty
            );
            return converted;
          }
        );
    }

    public updateDigicon(
      digicon: Models.IDigicon
    ): ng.IPromise<Models.IDigicon> {
      return this.backendService
        .put(this.backendUrl + '/' + digicon.id, {
          name: digicon.name,
          matchNumber: digicon.matchNumber,
          matchDay: digicon.matchDay,
          role: digicon.role,
          port: digicon.port,
          kit: digicon.kit,
          mode: digicon.mode,
          mainGateway: digicon.mainGateway,
          backupGateway: digicon.backupGateway,
        })
        .then(
          (
            result: ng.IHttpPromiseCallbackArg<Models.IHalElement<IDigicon>>
          ) => {
            let converted: IDigicon = HalConverter.convertElement(
              result.data,
              Digicon.Empty
            );
            return converted;
          }
        );
    }

    public deleteDigicon(digicon: Models.IDigicon): ng.IPromise<void> {
      return this.backendService
        .delete(this.backendUrl + '/' + digicon.id)
        .then(
          (
            result: ng.IHttpPromiseCallbackArg<Models.IHalElement<IDigicon>>
          ) => {}
        );
    }

      public applyDigicons(): ng.IPromise<void> {
          return this.backendService
              .get(this.backendUrl + '/apply')
              .then(
                  (
                      result: ng.IHttpPromiseCallbackArg<Models.IHalElement<IDigicon>>
                  ) => {}
              );
      }
  }
}
